/*globals require, module, $, BluugoBrowser, TCApi, swal, Confirm */
var Block = require('../libs/block');

module.exports = Block.extend({
    template: '#batch-production',

    init: function () {
        $('#submit-formset').click(function() {
            $("#formset").submit();
        });
    },
});
